import './duckhorn/style';
import FormStructure from './duckhorn/form_structure';

export default FormStructure;